<template>
  <up-dialog
    v-model="visible"
    width="924px"
    :show-close="false"
    custom-class="indicator__dialog"
    v-bind="$attrs"
    v-on="$listeners"
    @up:cancel="onCancel"
    @up:confirm="onConfirm"
  >
    <div class="indicator">
      <div class="indicator__left">
        <div class="indicator__header">
          <h2 class="indicator__title">全部指标</h2>
          <div class="indicator__operate">
            <el-link
              type="primary"
              :underline="false"
              @click="onSelectAllIndicators"
            >全选</el-link>
            <span class="indicator__split-line">/</span>
            <el-link
              type="primary"
              :underline="false"
              @click="onReverseSelectIndicators"
            >反选</el-link>
            <span class="indicator__split-line">/</span>
            <el-link
              type="primary"
              :underline="false"
              @click="onSelectDefaultIndictors"
            >默认</el-link>
          </div>
        </div>
        <div class="indicator__list">
          <template v-for="groupItem in data">

            <div class="indicator__check-all">
              <up-checkbox
                :indeterminate="groupItem.isIndeterminate"
                v-model="groupItem.checkAll"
                @change="(value) => handleCheckAllChange(value, groupItem)"
                >
                {{groupItem.name}}
              </up-checkbox>
            </div>
            <up-checkbox-group v-model="groupItem.checkValue" @change="(value) => handleCheckChange(value, groupItem)"  :key="groupItem.name" :data="groupItem.data">
              <div slot="up:item" slot-scope="{ item }" class="indicator__item">
                <!-- <span>{{ item.name }}</span> -->
                <up-popover width="236" trigger="hover" placement="top">
                  <span class="indicator__popover-content">{{ item.desc }}</span>
                  <span slot="reference">{{item.name}}</span>
                </up-popover>
              </div>
            </up-checkbox-group>
          </template>
        </div>
      </div>
      <div class="indicator__right">
        <h4 class="indicator__subtitle">拖拽指标调整显示顺序</h4>
        <draggable
          tag="ul"
          v-model="indicators"
          class="indicator__order-list"
          v-bind="dragOptions"
          @start="drag = true"
          @end="drag = false"
        >
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <template v-if="indicators.length">
              <li
                v-for="(item, index) in indicators"
                :key="item.value"
                class="indicator__order-item"
              >
                <i class="iconfont icon-move"></i>
                <span>{{ item.name }}</span>
                <i class="el-icon-close" @click="onRemoveIndicator(item, index)"></i>
              </li>
            </template>
            <li class="indicator__none" v-else key="none">暂无指标</li>
          </transition-group>
        </draggable>
      </div>
    </div>
  </up-dialog>
</template>

<script>
import draggable from 'vuedraggable'
import createVModel from '@/global/mixins/createVModel'

export default {
  name: 'Indicator',

  components: {
    draggable
  },

  mixins: [createVModel('visible')],

  props: {
    data: {
      type: Array,
      default: () => []
    },
    useChoose: {
      type: Boolean,
      default: true
    },
    defaultIndicators: {
      type: Array,
      default: () => []
    }
  },
  data() {
    this.selecting = false
    this.originalIndicatorValues = this.defaultIndicators.slice()
    return {
      // indicatorValues: this.defaultIndicators,
      indicators: [],
      drag: false
    }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'indicator',
        disabled: !this.indicators.length,
        ghostClass: 'ghost'
      }
    },
    indicatorValues: {
      get() {
        return this.data.reduce((prev, cur) => {
          prev.push(...cur.checkValue)
          return prev
        }, [])
      }
    }
  },

  watch: {
    data(newValue, oldValue) {
      this.allIndicators = newValue.reduce((prev, cur) => {
        prev.push(...cur.data.map(v => v.value))
        return prev
      }, [])
      // if (this.useChoose) {
      //   this.defaultIndicators = this.indicatorValues = newValue.reduce((prev, cur) => {
      //     if (cur.is_choose === 1) {
      //       prev.push(cur.value)
      //     }
      //     return prev
      //   }, [])
      // }
      this.onSelectDefaultIndictors()
    },
    indicatorValues(newValue, oldValue) {
      if (this.selecting) {
        this.indicators = this.setIndicator()
      } else {
        if (newValue.length > oldValue.length) { // 添加
          const values = newValue.filter(v => !oldValue.includes(v))
          this.indicators.push(...this.setIndicator(values))
        } else if (newValue.length < oldValue.length) { // 减少
          const values = oldValue.filter(v => !newValue.includes(v))
          this.indicators = this.indicators.filter(v => !values.includes(v.value))
        }
      }
      this.selecting = false
    },
    visible(newVal) {
      if (newVal) {
        this.originalIndicatorValues = this.indicatorValues.slice()
      }
    }
  },
  mounted() {
  },
  methods: {
    onCancel() {
      this.indicatorValues = this.originalIndicatorValues.slice()
    },
    onConfirm() {
      this.visible = false
      // this.indicatorValues = this.indicators.map(item => item.value)
      const { indicatorValues, indicators } = this
      this.$emit('confirm', {
        indicatorValues: indicatorValues,
        indicators
      })
    },
    setIndicator(indicatorValues = this.indicatorValues) {
      return this.data.reduce((prev, cur) => {
        prev.push(...cur.data.filter(v => indicatorValues.includes(v.value)))
        return prev
      }, [])
    },
    onRemoveIndicator(item, index) {
      this.data.forEach(itemData => {
        itemData.checkValue = itemData.checkValue.filter(value => item.value !== value )
      })
      // this.setIndicator()
    },
    onSelectAllIndicators() {
      this.data.forEach(item => {
        item.checkValue = item.data.map(k => k.value)
      })
      // this.setIndicator()

    },
    onReverseSelectIndicators() {
      this.selecting = true
      this.data.forEach(item => {
        item.checkValue = item.data.filter(v => !this.indicatorValues.includes(v.value)).map(k => k.value)
      })
      // this.setIndicator()

    },
    onSelectDefaultIndictors() {
      this.selecting = true
      this.data.forEach(item => {
        item.checkValue = item.data.filter(v => this.defaultIndicators.includes(v.value)).map(k => k.value)
      })
      this.setIndicator()
    },
    handleCheckAllChange(value, groupItem) {
      groupItem.isIndeterminate = false
      groupItem.checkValue = value ? groupItem.data.map(item => item.value) : []
      // this.setIndicator()
    },
    handleCheckChange(value, groupItem) {
      let checkedCount = value.length;
        groupItem.checkAll = checkedCount === groupItem.data.length;
        groupItem.isIndeterminate =
          checkedCount > 0 && checkedCount < groupItem.data.length;
      // this.setIndicator()

    }
  }
}
</script>

<style lang="scss">
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

@include b(indicator) {
  display: flex;
  padding: 30px 0 25px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e6e7ea;

  @include e(dialog) {
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding-bottom: 0 !important;
    }
  }

  @include e(header) {
    display: flex;
    justify-content: space-between;
    padding-right: 25px;
    padding-bottom: 25px;

    h2 {
      font-size: 18px;
      color: #333;
      font-weight: 500;
    }
  }

  @include e(left) {
    flex: 1;
  }

  @include e(list) {
    .el-checkbox {
      margin-right: 20px;
      margin-bottom: 20px;
    }
  }
  @include e(check-all) {
    height: 40px;
    background-color: #f9f9f9;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .el-checkbox{
      margin-bottom: 0px;
      color: #000;
    }
  }
  @include e(item) {
    display: flex;
    min-width: 108px;
    justify-content: space-between;
  }

  @include e(operate) {
    display: flex;
    align-items: center;

    .el-link {
      padding: 3px 7px;
    }
  }

  @include e(split-line) {
    font-size: 12px;
    // padding: 0 7px;
    color: #e6e7ea;
  }

  @include e(right) {
    flex: 0 0 262px;
    padding-left: 25px;
    border-left: 1px solid #e6e7ea;

    h4 {
      margin-bottom: 26px;
      color: #333;
    }
  }

  @include e(order-list) {
    // height: 220px;
    padding-right: 12px;
    overflow-y: scroll;
  }

  @include e(order-item) {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 36px;
    margin-bottom: 10px;
    padding: 0 7px;
    background-color: #f8f8f8;
    border-radius: 4px;
    cursor: move;

    span {
      margin-left: 10px;
      margin-right: auto;
    }

    .icontuodong {
      padding: 3px;
      font-size: 20px;
      color: #666;
      cursor: move;
    }
    .iconguanbi {
      padding: 3px;
      font-size: 12px;
      color: #9e9e9e;
      cursor: pointer;
    }
  }
  @include e(none) {
    text-align: center;
  }
}
</style>
